<template>
    <div :class="['input-group', {'error': hasError}]">
        <label v-if="label" :for="identifier">{{label}}
            <span v-if="tippyText"><font-awesome-icon :icon="['far','info-circle']" :content="`${tippyText}`" v-tippy="{ placement : 'top',  arrow: true }"/></span>
        </label>
        <textarea v-if="useTextarea" :id="identifier" :value="value" @input="(e)=>$emit('input', e.target.value)"
                  :placeholder="placeholder" :disabled="disabled" :autocomplete="autocomplete" :class="['input', {'large-textarea': largeTextarea}]"
                  :readonly="readonly"></textarea>
        <input v-else :id="identifier" :value="value" @input="(e)=>$emit('input', e.target.value)" @blur="(e)=>$emit('blur', e.target.value)" :type="type"
               :placeholder="placeholder" :disabled="disabled" :autocomplete="autocomplete" class="input"
               :readonly="readonly" :class="{'primary-border': borderColor === 'primary'}" :min="min" :maxlength="maxlength">
        <FormErrors v-if="hasError">
            <slot name="errors"></slot>
        </FormErrors>
    </div>
</template>

<script>
    import FormErrors from "./FormErrors";

    export default {
        name: "FormInputText",
        components: {FormErrors},
        props: {
            value: {
                type: [String, Number],
            },
            identifier: {
                type: String,
                default: null,
            },
            type: {
                type: String,
                default: 'text'
            },
            label: {
                type: String,
                default: null,
            },
            placeholder: {
                type: String,
                default: null
            },
            autocomplete: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            hasError: {
                type: Boolean,
                default: false
            },
            useTextarea: {
                type: Boolean,
                default: false,
            },
            readonly: {
                type: Boolean,
                default: false,
            },
            largeTextarea: {
                type: Boolean,
                default: false,
            },
            borderColor: {
                type: String,
                default: 'grey-light'
            },
            tippyText: {
                type: String,
                default: null,
            },
            min: {
                type: Number,
                default: 0
            },
            maxlength: {
                type: Number,
                require: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .input-group {
        @apply w-full flex flex-col items-start mb-5;

        label {
            @apply text-sm text-black font-bold mb-1;
        }

        .large-textarea{
            @apply resize-none;
            height: 8.75rem;
        }

        .input {
            @apply bg-white text-black text-sm font-normal border-2 border-grey-light rounded w-full py-3 px-5 appearance-none;

            &:focus {
                @apply border-primary outline-none;
            }

            &:disabled {
                @apply bg-grey-light;
            }
        }

        .primary-border {
            @apply border-primary;
        }

        ::-webkit-input-placeholder { /* Edge */
            color: theme('colors.grey-dark') !important;
            opacity: 1 !important;
        }

        :-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: theme('colors.grey-dark') !important;
            opacity: 1 !important;
        }

        ::placeholder {
            color: theme('colors.grey-dark') !important;
            opacity: 1 !important;
        }

        &.error {
            .input {
                @apply border-negative;
            }
        }
    }
</style>